module.exports = __webpack_public_path__ + "static/media/half-circle.c440d2ee.png";